// src/themes/index.ts
import { Theme } from "./types";
import { lightTheme } from "./light";
import { darkTheme } from "./dark";
import { forestTheme } from "./forest";
import { oceanTheme } from "./ocean";
import { sunsetTheme } from "./sunset";
import { royalGoldTheme } from "./royal-gold";
import { cyberChromeTheme } from "./cyber-chrome";
import { arcticBreezeTheme } from "./arctic-breeze";
import { mintFreshTheme } from "./mint-fresh";
import { cosmicPurpleTheme } from "./cosmic-purple";
// --- NEW ---
// Import desertSkyTheme which was missing from the original file
import { desertSkyTheme } from "./desert-sky";

export const THEMES: Record<string, Theme> = {
  light: lightTheme,
  dark: darkTheme,
  "theme-forest": forestTheme,
  "theme-ocean": oceanTheme,
  "theme-sunset": sunsetTheme,
  "theme-royal-gold": royalGoldTheme,
  "theme-cyber-chrome": cyberChromeTheme,
  "theme-arctic-breeze": arcticBreezeTheme,
  "theme-mint-fresh": mintFreshTheme,
  "theme-cosmic-purple": cosmicPurpleTheme,
  "theme-desert-sky": desertSkyTheme, // --- NEW ---
};

export const THEME_METADATA = [
  { name: "light", label: "Light", icon: "☀️" },
  { name: "dark", label: "Dark", icon: "🌙" },
  { name: "theme-forest", label: "Forest", icon: "🌲" },
  { name: "theme-ocean", label: "Ocean", icon: "🌊" },
  { name: "theme-sunset", label: "Sunset", icon: "🌅" },
  { name: "theme-royal-gold", label: "Royal Gold", icon: "👑" },
  { name: "theme-cyber-chrome", label: "Cyber Chrome", icon: "⚡" },
  { name: "theme-arctic-breeze", label: "Arctic Breeze", icon: "❄️" },
  { name: "theme-mint-fresh", label: "Mint Fresh", icon: "🌿" },
  { name: "theme-cosmic-purple", label: "Cosmic Purple", icon: "🌌" },
  { name: "theme-desert-sky", label: "Desert Sky", icon: "🏜️" }, // --- NEW ---
];

export const DEFAULT_THEME_NAME = "theme-mint-fresh";
